import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import homegallery2 from "../../assets/images/home/homegallery2.jpg";
import homegallery4 from "../../assets/images/home/homegallery4.jpg";
import homegallery6 from "../../assets/images/home/homegallery6.jpg";

function Section3() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    const organizerData = localStorage.getItem("organizer");
    if (organizerData) {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <>
      <section className="">
        <div className="homeblog">
          <div className="homeblogg">
            <div className="content content-overlay">
              <div className="column col-xs-6" id="zoomIn">
                <Link to="/about-us">
                  <figure>
                    <img src={homegallery4} alt="" />
                  </figure>

                  <div className="homblgtxt">
                    <div className="homblgtxtt">
                      <h3>About Us</h3>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="homeblogg">
            <div className="content content-overlay">
              <div className="column col-xs-6" id="zoomIn">
                {!isLoggedIn ? (
                  <>
                    <Link to="/login">
                      <figure>
                        <img src={homegallery2} alt="" />
                      </figure>
                      <div className="homblgtxt">
                        <div className="homblgtxtt">
                          <h3>Host A Seminar</h3>
                        </div>
                      </div>
                    </Link>
                  </>
                ) : (
                  <>
                    <Link to="/seminar">
                      <figure>
                        <img src={homegallery2} alt="" />
                      </figure>
                      <div className="homblgtxt">
                        <div className="homblgtxtt">
                          <h3>Host A Seminar</h3>
                        </div>
                      </div>
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="homeblogg">
            <div className="content content-overlay">
              <div className="column col-xs-6" id="zoomIn">
                <Link to="/contact">
                  <figure>
                    <img src={homegallery6} alt="" />
                  </figure>
                  <div className="homblgtxt">
                    <div className="homblgtxtt">
                      <h3>Contacts</h3>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Section3;
